import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const suppItem = ({ title, subtitle, img, color, shortName, data }) => {
    data.map((el, index) => {
        console.log(el.name);
    });
    return (
        <>
            <ScrollAnimation animateIn="fadeInUp">
                <img
                    src={img}
                    alt={shortName + " image"}
                    title={shortName}
                    style={{ borderColor: color, borderRadius: "1rem" }}
                />
            </ScrollAnimation>
            <ScrollAnimation animateIn="fadeInUp">
                <div
                    id={shortName}
                    className="listbox border-bottom"
                    style={{ borderColor: color }}
                >
                    <h2>{title}</h2>
                    <h3>{subtitle}</h3>
                    <ul className="table">
                        {data.map((d, index) => (
                            <li style={{ borderColor: color }}>
                                <span style={{ textAlign: "left" }}>
                                    {data[index].name}
                                </span>
                                <span style={{ textAlign: "right" }}>
                                    {data[index].stat}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </ScrollAnimation>
        </>
    );
};

export default suppItem;
